import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface DashboardCardProps {
  title: string;
  value: number;
  icon: LucideIcon;
  color: 'gray' | 'green' | 'orange' | 'amber' | 'red';
}

function DashboardCard({ title, value, icon: Icon, color }: DashboardCardProps) {
  const gradientClasses = {
    gray: 'from-gray-400 to-gray-600',
    green: 'from-green-400 to-green-600',
    orange: 'from-orange-400 to-orange-600',
    amber: 'from-amber-400 to-amber-600',
    red: 'from-red-400 to-red-600'
  };

  return (
    <div className="glass-card overflow-hidden rounded-xl card-hover">
      <div className="p-6">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className={`p-3 rounded-xl bg-gradient-to-br ${gradientClasses[color]} shadow-lg`}>
              <Icon className="h-6 w-6 text-white" />
            </div>
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-semibold text-gray-600 truncate uppercase tracking-wide">
                {title}
              </dt>
              <dd className="flex items-baseline">
                <div className="text-3xl font-bold text-gray-900">
                  {value}
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardCard;